export const xValues = [
  100,
  125,
  160,
  200,
  250,
  310,
  400,
  500,
  650,
  800,
  1000,
  1250,
  1600,
  2000,
  2500,
  3150,
  4000,
  5000
]

export const tableYValuesIndex = [
  1,
  4,
  7,
  10,
  13,
  16
];

export default {
  0: {
    0: [0.3, 0.37, 0.48, 0.69, 0.69, 0.88, 0.86, 0.89, 0.96, 0.93, 1.01, 1.02, 1.03, 0.98, 0.92, 0.85, 0.76, 0.68],
    1: [0.31, 0.38, 0.33, 0.7, 0.7, 0.85, 0.88, 0.9, 0.91, 0.93, 0.95, 0.98, 1.01, 0.91, 0.86, 0.79, 0.73, 0.65],
    2: [0.32, 0.4, 0.44, 0.74, 0.68, 0.86, 0.87, 0.86, 0.94, 0.95, 0.93, 0.94, 0.94, 0.88, 0.79, 0.72, 0.66, 0.61],
    3: [0.31, 0.37, 0.4, 0.73, 0.66, 0.88, 0.86, 0.86, 0.93, 0.93, 0.95, 0.93, 0.89, 0.79, 0.74, 0.67, 0.62, 0.58],
    4: [0.32, 0.38, 0.52, 0.65, 0.69, 0.86, 0.86, 0.85, 0.89, 0.89, 0.88, 0.87, 0.81, 0.76, 0.65, 0.63, 0.63, 0.62],
    5: [0.35, 0.44, 0.49, 0.68, 0.63, 0.8, 0.79, 0.8, 0.84, 0.8, 0.8, 0.75, 0.68, 0.61, 0.53, 0.47, 0.46, 0.43],
    6: [0.3, 0.37, 0.52, 0.67, 0.69, 0.78, 0.78, 0.79, 0.76, 0.77, 0.71, 0.66, 0.58, 0.51, 0.46, 0.47, 0.48, 0.44],
    7: [0.38, 0.45, 0.51, 0.65, 0.64, 0.69, 0.68, 0.67, 0.64, 0.6, 0.53, 0.47, 0.42, 0.37, 0.33, 0.3, 0.32, 0.32],
    8: [0.39, 0.41, 0.47, 0.53, 0.49, 0.5, 0.51, 0.42, 0.4, 0.34, 0.32, 0.29, 0.25, 0.23, 0.21, 0.2, 0.2, 0.24],
    9: "",
  },
  1: { // PETITS OBLONGS
    0: [0.27,0.38,0.65,0.85,1.16,1.14,1.02,	0.95,0.84,0.79,0.71,0.68,0.66,0.63,0.59,0.53,0.5,0.49],
    1: "",
    2: ""
  },
  2: {  // GRANDS OBLONGS
  /**[0.30, 0.25, 0.25, 0.25, 0.25, 0.25, 0.25, 0.25, 0.25, 0.25, 0.25, 0.25, 0.25, 0.25, 0.25, 0.25, 0.25, 0.25]*/},

  3: { // RAINURES
    0: [0.39, 0.42, 0.49, 0.73, 0.81, 0.87, 0.87, 0.95, 0.99, 0.98, 1.03, 0.99, 1.01, 0.92, 0.84, 0.78, 0.78, 0.81],
    1: [0.4, 0.43, 0.49, 0.73, 0.78, 0.85, 0.88, 0.9, 0.93, 0.93, 0.95, 0.9, 0.88, 0.74, 0.66, 0.59, 0.6, 0.59],
    2: [0.41, 0.44, 0.51, 0.65, 0.73, 0.79, 0.78, 0.82, 0.85, 0.83, 0.81, 0.78, 0.69, 0.62, 0.53, 0.51, 0.54, 0.54]
  },

  4: [0.51, 0.45, 0.58, 0.6, 0.78, 0.86, 0.88, 0.91, 1.01, 1.05, 1.11, 1.13, 1.1, 1.04, 0.95, 0.88, 0.8, 0.67],
/*
  5:  {  //Ronds
    0: [
      [0.34, 0.49, 0.56, 0.7, 0.92, 1.01, 0.83, 0.75, 0.62, 0.54, 0.53, 0.5, 0.4, 0.29, 0.23, 0.21, 0.15, 0.13],  //    P3E16
      "",   //    P3E20
      ""    //    P3E32
    ],
    1: [
      "",    //    P6E16
      "",   //    P6E20
      ""    //    P6E32
    ],
    2: [
      [0.49, 0.47, 0.54, 0.81, 0.89, 0.94, 1.07, 1.07, 1.07, 1.06, 1.06, 1.07, 1.01, 0.89, 0.8, 0.71, 0.67, 0.7],  //P8E16
      [0.26, 0.41, 0.6, 0.85, 1.08, 1.21, 0.96, 0.89, 0.81, 0.73, 0.64, 0.61, 0.58, 0.52, 0.46, 0.46, 0.42, 0.48],  //P8E20
      [0.34, 0.51, 0.72, 1.03, 1.04, 0.89, 0.69, 0.54, 0.44, 0.37, 0.31, 0.29, 0.26, 0.24, 0.23, 0.22, 0.19, 0.22], //P8E32
    ],
    3: [
      "", //P10E20
      ""  //P10E32
    ]
  },
*/
 // RONDS  à affiner

 5:  {  //Ronds
    0:[0.34, 0.49, 0.56, 0.7, 0.92, 1.01, 0.83, 0.75, 0.62, 0.54, 0.53, 0.5, 0.4, 0.29, 0.23, 0.21, 0.15, 0.13],
    1:"",
    2:"",
    3:"",
    4:"",
    5:"",
    6:[0.49, 0.47, 0.54, 0.81, 0.89, 0.94, 1.07, 1.07, 1.07, 1.06, 1.06, 1.07, 1.01, 0.89, 0.8, 0.71, 0.67, 0.7],
    7:[0.26, 0.41, 0.6, 0.85, 1.08, 1.21, 0.96, 0.89, 0.81, 0.73, 0.64, 0.61, 0.58, 0.52, 0.46, 0.46, 0.42, 0.48],
    8:[0.34, 0.51, 0.72, 1.03, 1.04, 0.89, 0.69, 0.54, 0.44, 0.37, 0.31, 0.29, 0.26, 0.24, 0.23, 0.22, 0.19, 0.22],
    9:"",
    10:""
  },

  6: { //ETIRER - STRETCH
    0: [0.35, 0.36, 0.43, 0.68, 0.67, 0.82, 0.87, 0.89, 0.92, 0.93, 0.97, 0.95, 0.91, 0.81, 0.73, 0.7, 0.62, 0.54],
    1: "",
    2: "",
    3: "",
    4: ""
    //5: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  },
  7: { // GOMMER - ERASE
    0: [0.32, 0.37, 0.48, 0.69, 0.81, 0.92, 0.94, 0.98, 0.94, 0.91, 0.81, 0.61, 0.45, 0.34, 0.26, 0.21, 0.18, 0.16],
    //1: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    //2: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    3: [0.32, 0.37, 0.57, 0.75, 0.74, 0.86, 0.87, 0.85, 0.76, 0.65, 0.51, 0.36, 0.26, 0.2, 0.19, 0.21, 0.22, 0.23]
    //4: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  },
  8: { // GRAISSER - GREASE
    /*
    0: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    1: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    2: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    3: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    4: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    5: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    6: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    7: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    8: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    9: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    10: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    11: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    12: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    13: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    14: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    15: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    16: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    17: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    18: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    19: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    20: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    */
  },
  9: { //SECOUER
    0: "",
    1: [0.33, 0.38, 0.46, 0.66, 0.73, 0.86, 0.88, 0.86, 0.92, 0.85, 0.76, 0.68, 0.59, 0.53, 0.46, 0.39, 0.29, 0.25],
    2: "",
    3: "",
    4: [0.32,	0.35,	0.42,	0.69,	0.72,	0.83,	0.88,	0.86,	0.91,	0.89,	0.84,	0.77,	0.71,	0.66,	0.59,	0.52,	0.4, 0.36]
  },
  10: { // SOUFFLER
    0: [0.34, 0.36, 0.53, 0.55, 0.57, 0.62, 0.59, 0.61, 0.62, 0.66, 0.69, 0.76, 0.77, 0.8, 0.82, 0.78, 0.61, 0.56],
    1: [0.34, 0.36, 0.53, 0.55, 0.57, 0.62, 0.59, 0.61, 0.62, 0.66, 0.69, 0.76, 0.77, 0.8, 0.82, 0.78, 0.61, 0.56],
    2: [0.34, 0.36, 0.53, 0.55, 0.57, 0.62, 0.59, 0.61, 0.62, 0.66, 0.69, 0.76, 0.77, 0.8, 0.82, 0.78, 0.61, 0.56],
    3: [0.34, 0.36, 0.53, 0.55, 0.57, 0.62, 0.59, 0.61, 0.62, 0.66, 0.69, 0.76, 0.77, 0.8, 0.82, 0.78, 0.61, 0.56],
    4: [0.34, 0.36, 0.53, 0.55, 0.57, 0.62, 0.59, 0.61, 0.62, 0.66, 0.69, 0.76, 0.77, 0.8, 0.82, 0.78, 0.61, 0.56],
    5: [0.34, 0.36, 0.53, 0.55, 0.57, 0.62, 0.59, 0.61, 0.62, 0.66, 0.69, 0.76, 0.77, 0.8, 0.82, 0.78, 0.61, 0.56],
    6: [0.34, 0.36, 0.53, 0.55, 0.57, 0.62, 0.59, 0.61, 0.62, 0.66, 0.69, 0.76, 0.77, 0.8, 0.82, 0.78, 0.61, 0.56],
    7: [0.34, 0.36, 0.53, 0.55, 0.57, 0.62, 0.59, 0.61, 0.62, 0.66, 0.69, 0.76, 0.77, 0.8, 0.82, 0.78, 0.61, 0.56]

  },
  11: [0.49, 0.5, 0.45, 0.62, 0.63, 0.67, 0.65, 0.64, 0.57, 0.52, 0.46, 0.4, 0.38, 0.33, 0.29, 0.27, 0.22, 0.22], // prairie
  12: [0.51, 0.47, 0.49, 0.6, 0.58, 0.6, 0.54, 0.54, 0.51, 0.47, 0.43, 0.39, 0.4, 0.37, 0.34, 0.31, 0.23, 0.21], // brindille
  13: [0.41, 0.42, 0.48, 0.76, 0.87, 0.86, 0.95, 0.94, 0.96, 0.98, 0.97, 0.96, 0.91, 0.78, 0.67, 0.56, 0.42, 0.39], // taillis
  14: [0.47, 0.43, 0.46, 0.6, 0.61, 0.62, 0.64, 0.65, 0.66, 0.62, 0.56, 0.52, 0.5, 0.44, 0.39, 0.34, 0.28, 0.27], //Ecorce"
  15: [0.41, 0.33, 0.34, 0.38, 0.37, 0.4, 0.33, 0.32, 0.28, 0.25, 0.23, 0.21, 0.21, 0.2, 0.18, 0.16, 0.15, 0.2], //Liane"
  16: [0.48, 0.51, 0.54, 0.73, 0.77, 0.76, 0.74, 0.7, 0.61, 0.55, 0.43, 0.34, 0.3, 0.29, 0.25, 0.23, 0.19, 0.19], //Chair de poule"
  17: [0.47, 0.47, 0.52, 0.61, 0.64, 0.67, 0.54, 0.49, 0.37, 0.3, 0.25, 0.2, 0.19, 0.17, 0.15, 0.14, 0.13, 0.12], //Grain de beauté"
  18: [0.48, 0.47, 0.55, 0.73, 0.76, 0.82, 0.82, 0.84, 0.8, 0.77, 0.72, 0.62, 0.59, 0.51, 0.45, 0.39, 0.31, 0.31], //Ecaille"
  19: [0.28, 0.21, 0.24, 0.2, 0.21, 0.2, 0.17, 0.15, 0.14, 0.12, 0.11, 0.11, 0.11, 0.11, 0.1, 0.08, 0.05, 0.07], //Fourrure"
  20: [0.55, 0.51, 0.53, 0.77, 0.82, 0.84, 0.89, 0.85, 0.88, 0.81, 0.77, 0.69, 0.65, 0.56, 0.49, 0.46, 0.37, 0.33], //Ligne de vie"
  21: [0.36, 0.34, 0.35, 0.36, 0.35, 0.35, 0.29, 0.27, 0.23, 0.2, 0.18, 0.16, 0.15, 0.15, 0.13, 0.13, 0.12, 0.14], //Canevas"
  22: [0.46, 0.4, 0.41, 0.52, 0.54, 0.54, 0.49, 0.49, 0.47, 0.41, 0.36, 0.32, 0.29, 0.27, 0.23, 0.21, 0.15, 0.14], //Patchwork"
  23: [0.44, 0.42, 0.49, 0.73, 0.81, 0.84, 0.95, 0.98, 0.97, 0.98, 1.01, 1.02, 1.02, 0.92, 0.83, 0.69, 0.58, 0.55], //Jersey"
  24: [0.24, 0.19, 0.19, 0.12, 0.12, 0.11, 0.09, 0.07, 0.07, 0.07, 0.06, 0.07, 0.09, 0.1, 0.08, 0.07, 0.05, 0.06], //Capiton"
  25: [0.47, 0.45, 0.52, 0.72, 0.74, 0.76, 0.81, 0.83, 0.79, 0.76, 0.77, 0.67, 0.61, 0.49, 0.38, 0.32, 0.23, 0.2], //Ecossais"
  26: [0.2, 0.17, 0.2, 0.15, 0.15, 0.14, 0.11, 0.1, 0.09, 0.09, 0.08, 0.08, 0.1, 0.11, 0.11, 0.1, 0.07, 0.09], //Brume"
  27: [0.45, 0.45, 0.48, 0.62, 0.65, 0.68, 0.71, 0.73, 0.72, 0.67, 0.64, 0.59, 0.55, 0.5, 0.44, 0.41, 0.35, 0.35], //Pluie"
  28: [0.36, 0.35, 0.36, 0.36, 0.36, 0.36, 0.31, 0.29, 0.26, 0.22, 0.2, 0.18, 0.19, 0.19, 0.18, 0.16, 0.13, 0.15], //Soleil"
  29: [0.5, 0.44, 0.44, 0.54, 0.54, 0.54, 0.48, 0.46, 0.41, 0.36, 0.32, 0.3, 0.32, 0.3, 0.26, 0.23, 0.16, 0.14], //Vent"
  30: [0.5, 0.5, 0.53, 0.72, 0.7, 0.72, 0.65, 0.6, 0.55, 0.47, 0.38, 0.31, 0.29, 0.25, 0.22, 0.2, 0.16, 0.16], //Neige"
  31: [0.43, 0.46, 0.48, 0.72, 0.76, 0.78, 0.85, 0.85, 0.84, 0.79, 0.74, 0.65, 0.59, 0.5, 0.42, 0.38, 0.33, 0.32], //Amplitude"
  32: [0.45, 0.44, 0.51, 0.74, 0.79, 0.83, 0.93, 0.95, 0.99, 0.98, 0.95, 0.96, 0.91, 0.83, 0.73, 0.67, 0.57, 0.58], //Onde"
  33: [0.39, 0.43, 0.55, 0.71, 0.73, 0.82, 0.9, 0.92, 0.93, 0.92, 0.92, 0.92, 0.87, 0.8, 0.73, 0.69, 0.62, 0.58], //Crépitement"
  34: [0.5, 0.46, 0.42, 0.53, 0.58, 0.58, 0.55, 0.53, 0.53, 0.49, 0.47, 0.43, 0.41, 0.38, 0.33, 0.28, 0.24, 0.23], //Cadence"
  35: [0.45, 0.44, 0.49, 0.58, 0.61, 0.63, 0.66, 0.67, 0.67, 0.68, 0.68, 0.61, 0.6, 0.54, 0.45, 0.4, 0.34, 0.32] //Fréquence
}



// WEBPACK FOOTER //
// ./src/constants/patternAcousticPerformances.js